import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { useTranslation } from 'react-i18next';
import isMultiDomain from 'utils/isMultiDomain';
import { ASSET_CONTENT_TYPES } from 'screens/AssetEditor/constants';
import ModalWrapper from './ModalWrapper';
import GeneralDetailsPanel from './Panels/GeneralDetailsPanel';
import ParentPlaylistsInfo from './Panels/ParentPlaylistsInfo';
import ImageDetailsPanel from './Panels/ImageDetailsPanel';
import LinkDetailsPanel from './Panels/LinkDetailsPanel';
import VideoDetailsPanel from './Panels/VideoDetailsPanel';
import ScormDetailsPanel from './Panels/ScormDetailsPanel';
import MicrositeDetailsPanel from './Panels/MicrositeDetailsPanel';
import AudioDetailsPanel from './Panels/AudioDetailsPanel';
import DocumentDetailsPanel from './Panels/DocumentDetailsPanel';
import FileDetailsPanel from './Panels/FileDetailsPanel';
import CreatedByInfo from './Panels/CreatedByInfo';
import InParentPlaylistPanel from './Panels/InParentPlaylistPanel';
import Panel from 'components/Panel';
import Hint from 'components/Hint';
var AssetDetailsModal = function AssetDetailsModal(_ref) {
  var _detailsPanels;
  var isEditMode = _ref.isEditMode,
    isNewFile = _ref.isNewFile,
    isProcessingError = _ref.isProcessingError,
    isLoading = _ref.isLoading,
    isSubmitDisabled = _ref.isSubmitDisabled,
    showUploadProgress = _ref.showUploadProgress,
    fields = _ref.fields,
    assetContentType = _ref.assetContentType,
    uploadProgress = _ref.uploadProgress,
    content = _ref.content,
    aiSuggestions = _ref.aiSuggestions,
    onReplace = _ref.onReplace,
    onDelete = _ref.onDelete,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    parentPlaylistName = _ref.parentPlaylistName,
    inContentManagerContext = _ref.inContentManagerContext;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isItemDistributed = isMultiDomain(content);
  var detailsPanels = (_detailsPanels = {}, _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.WEBLINK, /*#__PURE__*/React.createElement(LinkDetailsPanel, {
    id: content === null || content === void 0 ? void 0 : content.id,
    fields: fields,
    lastUpdated: content === null || content === void 0 ? void 0 : content.lastUpdated,
    content: content
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.IMAGE, /*#__PURE__*/React.createElement(ImageDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.VIDEO, /*#__PURE__*/React.createElement(VideoDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.SCORM, /*#__PURE__*/React.createElement(ScormDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.MICROSITE, /*#__PURE__*/React.createElement(MicrositeDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.AUDIO, /*#__PURE__*/React.createElement(AudioDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.DOCUMENT, /*#__PURE__*/React.createElement(DocumentDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _defineProperty(_detailsPanels, ASSET_CONTENT_TYPES.FILE, /*#__PURE__*/React.createElement(FileDetailsPanel, {
    isEditMode: isEditMode,
    isNewFile: isNewFile,
    isProcessingError: isProcessingError,
    showUploadProgress: showUploadProgress,
    uploadProgress: uploadProgress,
    content: content,
    fields: fields,
    onReplace: onReplace,
    onDelete: onDelete
  })), _detailsPanels);
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    isEditMode: isEditMode,
    isLoading: isLoading,
    isSubmitDisabled: isSubmitDisabled,
    assetContentType: assetContentType,
    onSubmit: onSubmit,
    onClose: onClose,
    inContentManagerContext: inContentManagerContext
  }, isEditMode && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(CreatedByInfo, {
    author: content === null || content === void 0 ? void 0 : content.author
  }), /*#__PURE__*/React.createElement(ParentPlaylistsInfo, {
    parentPlaylists: content === null || content === void 0 ? void 0 : content.parentPlaylists
  }), isItemDistributed && /*#__PURE__*/React.createElement(Hint, {
    icon: "share"
  }, t('immutability_note_distributed_item_fields'))), /*#__PURE__*/React.createElement(GeneralDetailsPanel, {
    fields: fields,
    content: content,
    aiSuggestions: aiSuggestions,
    isScormCourse: assetContentType === ASSET_CONTENT_TYPES.SCORM,
    isDistributed: isItemDistributed
  }), parentPlaylistName && /*#__PURE__*/React.createElement(InParentPlaylistPanel, {
    completionMode: fields.completionMode.value,
    onCompletionModeChange: function onCompletionModeChange(newMode) {
      return fields.completionMode.set(newMode);
    },
    parentPlaylistName: parentPlaylistName
  }), !isItemDistributed && detailsPanels[assetContentType]);
};
export default AssetDetailsModal;